import { NgModule } from '@angular/core';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { environment } from '../environments/environment';
import { onError } from 'apollo-link-error';


const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      let error = {
        message: message,
        locations: path.join(','),
        line: locations.map(x => `${x.line}:${x.column}`).join(',')
      }
      console.error(error);
      if (error.message == "Not Authenticated" || error.message == "jwt expired") {
        sessionStorage.clear();
        sessionStorage.setItem("lastUrl",window.location.pathname +window.location.search);
        location.href = '/authentication/login';
      }
    }
    );
  if (networkError) console.error(`[Network error]: ${networkError}`);
});


export function createApollo(httpLink: HttpLink) {

  return {
    link: errorLink.concat(httpLink.create({ uri: `${environment.PropertyPlatformGQLHost}` })), //CONTOH
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    }
  };
}


@NgModule({
  exports: [ApolloModule, HttpLinkModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule { }
